import { Box } from '@ksyos/design-system';
import { styled } from 'styled-components';

export const StyledBox = styled(Box)`
    display: flex;
    flex-direction: column;
    padding: 24px 0;
    gap: 8px;

    @media (min-width: 1024px) {
        flex-direction: row;
        flex-grow: 1;
    }
`;
